import React  from 'react';
import haiwaisanhuisanbaoguanlixize from '../assets/img/haiwaisanhuisanbaoguanlixize.png';
import haiwaizhoubaomuban from '../assets/img/haiwaizhoubaomuban.png';
import haiwaiyuebaomuban from '../assets/img/haiwaiyuebaomuban.png';
const Enclosure626 = () => 
    <div
        style={{
            WebkitTouchCallout:'none',  /*系统默认菜单被禁用*/
            MozUserSelect: 'none',  /*火狐*/
            WebkitUserSelect: 'none',  /*webkit浏览器*/
            msUserSelect: 'none',  /*IE10*/
            khtmlUserSelect: 'none',  /*早期浏览器*/
            userSelect: 'none',
        }}
     >
        <div style={{ textIndent: '2em' }}>
        <img src={haiwaisanhuisanbaoguanlixize} alt="" style={{ width  : '90%', display: 'block', margin : '0 auto' }}/>
        <br/><br/>
        <h4>附件：海外员工周报模板</h4>
        <img src={haiwaizhoubaomuban} alt="" style={{ width  : '90%', display: 'block', margin : '0 auto' }}/>
        <br/><br/>
        <h4>附件：海外分公司月报表模板</h4>
        <img src={haiwaiyuebaomuban} alt="" style={{ width  : '90%', display: 'block', margin : '0 auto' }}/>

        
                        

            <br/><br/>
        </div>
    </div>


export default Enclosure626;